import { Address } from './types'
import i18next from '../i18n'

const referral = {
  step: [
    {
      title: i18next.t('CONSTANT_8'),
      content: i18next.t('CONSTANT_9'),
      statusColor: '#39D9FF',
      imgNumber: require('../assets/images/invite/1.svg').default,
      imgBg: require('../assets/images/home/blue.svg').default,
    },
    {
      title: i18next.t('CONSTANT_10'),
      content: i18next.t('CONSTANT_11'),
      statusColor: '#FFA952',
      imgNumber: require('../assets/images/invite/2.svg').default,
      imgBg: require('../assets/images/home/orange.svg').default,
    },
    {
      title: i18next.t('CONSTANT_12'),
      content: i18next.t('CONSTANT_13'),
      statusColor: '#14D89D',
      imgNumber: require('../assets/images/invite/3.svg').default,
      imgBg: require('../assets/images/home/green.svg').default,
    },
  ],
  reward: [i18next.t('CONSTANT_14'), i18next.t('CONSTANT_15'), i18next.t('CONSTANT_16')],
}

const mainnetEnvName = ['production-mainnet', 'preview']

const isMainnet = mainnetEnvName.includes(process.env.REACT_APP_ENV_NAME ?? '')

export const shareTitle = i18next.t('CONSTANT_17')

export const shareUrl = isMainnet
  ? 'https://app.mojitoswap.finance/referral'
  : 'https://testnet.mojitoswap.finance/referral'

export const twitterShareTag = ['Bitcoin', 'Defi', 'MojitoSwap']

export const facebookShareTag = '#MojitoSwap'

export const referralConfig: Address[] = [
  {
    321: '0x91E609094Aeb6Cb4cEDc6d3175694fd90d7e2690',
    322: '0x3783949E8D1861AcAcc4AdA9A4604e6E962Fe48d',
  },
  {
    321: '0xD3BA7e2F0589aa0c61c51ceC872202b6066129fc',
    322: '0x9e5af01E0f228d309a078BE70392EBF8b8a9608d',
  },
  {
    321: '0x5D36A4DB638D7B4b6C2A8df616c181B7a9E7ECB0',
    322: '0x182252dBA6E64A163914Fb96ABBDE5246CCE3a61',
  },
  {
    321: '0xA76Ee9e227d0De5277EbBf2f67375c648844Ce42',
    322: '0x7d7B832685C566d7234fea21609F635ab3802D87',
  },
  {
    321: '0xB4eBEA9AE9d3fFFA344926e7Dc388E35F2Cd44E3',
    322: '0x5BFF2b172177b6E83361510175C8884600dc78B4',
  },
  {
    321: '0xbe9b516987dDb3CFb54508B1dA119b17552be7E8',
    322: '0x34E6fcd7949680CeF8b4d71A98ddB55F304B7db8',
  },
  {
    321: '0x9Dd2Ae950Ade895517D282E8C0Ef111607Db5B85',
    322: '0x2dA9b6f431A050a73f01ceFC900e834606EC0Bf3',
  },
]

export default referral
